/* @flow */
import React from 'react';
// $FlowIgnore
import { MdOpenInBrowser } from 'react-icons/md';

export default function OpenModalIcon({
  style
}: Object): React.Element {
  return <MdOpenInBrowser style={style} />;
}
